import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mv-ngx-bootstrap-slider',
  template: `
    <p>
      ngx-bootstrap-slider works!
    </p>
  `,
  styles: []
})
export class NgxBootstrapSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
